module.exports = __webpack_public_path__ + "2c81093e925212d3784ccf7eb3a8d740.svg";